export default "__VITE_ASSET__BhgDCgRW__"